<template>
  <v-app>
    <user-pages-core-app-bar />

    <user-pages-core-view />

    <user-pages-core-footer />

    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

  </v-app>
</template>

<script>

export default {
  name: "PagesIndex",

  components: {
    UserPagesCoreAppBar: () => import("./components/core/AppBar"),
    UserPagesCoreFooter: () => import("./components/core/Footer"),
    UserPagesCoreView: () => import("./components/core/View")
  },

  data() {
    return {
      loading: false,
    }
  },

  methods: {
    fetchProfile() {
      this.loading = true;
      this.$store
        .dispatch("userAccountService/getUserAccount")
        .then(() => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.$vuetify.theme.dark = false;
    this.fetchProfile();
  },

  beforeDestroy() {
    this.$vuetify.theme.dark = false;
  }
};
</script>
